import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import { makeStyles } from "@material-ui/core/styles"
import ArrowForwardIcon from "@material-ui/icons/ArrowForward"
import { Box, Card, Grid, Typography } from "@material-ui/core"
import {
  Button,
  FormikForm,
  FormikFormContainer,
} from "@ridecell/web-components-material"
import { Ridecell } from "@ridecell/web-sdk"

import useGlobalContext from "../../../utils/customHooks/useGlobalContext"
import DriverLicenseValidation from "./DriverLicenseValidation"
import LoadingButton from "../../LoadingButton"

import UploadFile from "./UploadFile"
import messages from "./messages"

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  card: {
    margin: "24px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)",
    borderRadius: "4px",
  },
  titleText: {
    textAlign: "center",
    margin: "10px",
  },
  identityCard: {
    maxHeight: "50vh",
    marginBottom: "16px",
    overflowY: "scroll",
  },
})

const UploadDocuments = ({
  handleNext,
  intl: { formatMessage },
  createCustomer,
  licenseValidationRequired,
  mivCompleted,
  ...props
}) => {
  const classes = useStyles()
  const [step, setStep] = useState(mivCompleted ? 1 : 0)
  const [mivDocs, setMivDocs] = useState(null)
  const [requiredFiles, setRequiredFiles] = useState([])
  const [uploadedFiles, setUploadedFiles] = useState([])
  const {
    state: { customer, loading },
    toggleBackdrop,
    setLoading,
  } = useGlobalContext()

  useEffect(() => {
    ;(async () => {
      toggleBackdrop(true)
      try {
        let resp = await Ridecell.getDocumentSpecificationForMIV()
        setMivDocs(resp.results)
        const requiredDocs = resp.results
          .filter((result) => result.required)
          .map((result) => result.id)
        setRequiredFiles(requiredDocs)
      } catch (e) {
        alert(e?.response?.data?.message || formatMessage(messages.error))
      } finally {
        toggleBackdrop(false)
      }
    })()
  }, [])

  const checkIsValid = () => {
    return requiredFiles.every((val) => uploadedFiles.includes(val))
  }

  const onUploadDoc = async () => {
    try {
      setLoading(true)
      await Ridecell.completeDocumentSubmission({
        customerId: customer.id,
        data: { completed_submission: true },
      })
      if (licenseValidationRequired) setStep(1)
      else handleNext()
    } catch (e) {
      //throw error
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (step === 1 && !licenseValidationRequired) handleNext()
  }, [step])

  const isValid = checkIsValid()
  return (
    <React.Fragment>
      {step === 0 && (
        <Grid item xs={8} sm={8} md={8} lg={8} xl={6.5}>
          <Card className={classes.card}>
            <Box
              display={"flex"}
              sx={{ mb: "16px" }}
              justifyContent="center"
              alignContent="center"
            >
              <Typography className={classes.titleText}>
                {formatMessage(messages.uploadDocumentMessage)}
              </Typography>
            </Box>

            <FormikFormContainer initialValues={{}} onSubmit={onUploadDoc}>
              {() => (
                <FormikForm>
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    spacing={1}
                    className={classes.identityCard}
                  >
                    {mivDocs &&
                      mivDocs.map((mivDoc) => {
                        const buttonText = `${mivDoc.display_name} ${
                          mivDoc.required ? "*" : ""
                        }`
                        return (
                          <UploadFile
                            buttonText={buttonText}
                            mivDocID={mivDoc.id}
                            uploadedFiles={uploadedFiles}
                            setUploadedFiles={setUploadedFiles}
                            key={mivDoc.id}
                          />
                        )
                      })}
                  </Grid>
                  <Box
                    display={"flex"}
                    sx={{ mb: "16px" }}
                    justifyContent="center"
                    alignContent="center"
                  >
                    <LoadingButton
                      disabled={!isValid}
                      text={formatMessage(messages.next)}
                      variant="contained"
                      loading={loading}
                      fullWidth
                      props={{
                        fullWidth: true,
                        type: "submit",
                        endIcon: <ArrowForwardIcon />,
                        size: "large",
                      }}
                    />
                  </Box>
                </FormikForm>
              )}
            </FormikFormContainer>
          </Card>
        </Grid>
      )}
      {step === 1 && <DriverLicenseValidation handleNext={handleNext} />}
    </React.Fragment>
  )
}

export default injectIntl(UploadDocuments)
